export default __webpack_public_path__ + "static/media/forgot-password-confirm.f05bec81.png";